import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Layout from "@/components/Layout";
import { Gavel, Trophy, ArrowRight, Clock } from "lucide-react";

export default function MyBids() {
  const [bids, setBids] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/me/bids");
        setBids(data);
      } finally { setLoading(false); }
    })();
  }, []);
  return (
    <Layout>
      <div className="flex items-center gap-3 mb-6">
        <Gavel strokeWidth={3} className="w-7 h-7"/>
        <h1 className="font-fredoka text-4xl font-bold">My bid history</h1>
      </div>
      {loading ? (
        <div className="brut-card p-6">Loading…</div>
      ) : bids.length === 0 ? (
        <div className="brut-card p-8 text-center bg-white">
          <div className="font-fredoka text-xl font-bold">No bids yet</div>
          <p className="mt-2 text-sm text-gray-700">Place a sealed bid on any live auction to see it here.</p>
          <Link to="/dashboard" className="brut-btn mt-4 inline-flex">Browse auctions</Link>
        </div>
      ) : (
        <div className="grid gap-3">
          {bids.map(b => (
            <Link to={`/auctions/${b.auction_id}`} key={b.auction_id}
              data-testid={`mybid-row-${b.auction_id}`}
              className="brut-card p-4 bg-white flex items-center justify-between hover:bg-cream">
              <div>
                <div className="font-fredoka font-bold text-lg">{b.auction_title}</div>
                <div className="text-xs text-gray-700 flex items-center gap-2 mt-1">
                  {b.auction_status === "closed" ? (
                    <>
                      {b.won ? (
                        <span className="chip bg-sunny"><Trophy strokeWidth={3} className="w-3.5 h-3.5"/>You won · paid {b.winning_price} pts</span>
                      ) : (
                        <span className="chip bg-white">Lost · winner paid {b.winning_price} pts</span>
                      )}
                    </>
                  ) : (
                    <span className="chip bg-mint"><Clock strokeWidth={3} className="w-3.5 h-3.5"/>Live · closes {new Date(b.closes_at).toLocaleString()}</span>
                  )}
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="text-right">
                  <div className="text-xs text-gray-600">Your bid</div>
                  <div className="font-fredoka text-2xl font-bold">{b.my_bid}</div>
                </div>
                <ArrowRight strokeWidth={3} className="w-5 h-5"/>
              </div>
            </Link>
          ))}
        </div>
      )}
    </Layout>
  );
}
